import { useVirtualizer } from '@tanstack/react-virtual';
import React, { useEffect } from 'react';
import { VirtualizedItem } from '../components/VirtualizedItem';
import { useSearch } from '../hooks/useSearch';

const ITEM_HEIGHT = 46;

export const VirtualizedList = () => {
  const parentRef = React.useRef(null);
  const { selectedItem, resultsByCategory, search, category } = useSearch();

  const rowVirtualizer = useVirtualizer({
    count: resultsByCategory.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ITEM_HEIGHT,
    overscan: 12,
  });

  // Reset scroll position when search or category changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    rowVirtualizer.scrollToIndex(0);
  }, [search, category]);

  // Keep selected item visible in viewport
  useEffect(() => {
    if (selectedItem) {
      const selectedIndex = resultsByCategory.findIndex((item) => item.id === selectedItem.id);
      if (selectedIndex !== -1) rowVirtualizer.scrollToIndex(selectedIndex, { align: 'auto' });
    }
  }, [selectedItem, resultsByCategory, rowVirtualizer]);

  return (
    <div ref={parentRef} className='relative h-[500px] w-full overflow-auto'>
      <div className='relative w-full' style={{ height: `${rowVirtualizer.getTotalSize()}px` }}>
        {rowVirtualizer.getVirtualItems().map((virtualRow) => (
          <VirtualizedItem key={`${virtualRow.index}`} virtualRow={virtualRow} />
        ))}
      </div>
    </div>
  );
};
